import React, { useContext, useEffect } from "react";
import { useTheme } from "@emotion/react";
import StrategyListItem from "../../components/StrategyListItem";
import { StrategyCategoryOrderContext } from "../../utils/strategy";
import { useExternalState } from "../../utils/me";
import { NavContext } from "../../utils/nav";
import { Container, Background, Title, Body, StrategyList } from "./styles";
import { InlineRichText } from "../../components/RichText";

const StrategyCategory = ({ navigation, route }) => {
	const { setLeafNav } = useContext(NavContext);
	const {
		api: { markContentAsRead },
	} = useExternalState();
	const { strategyCategoryId } = route.params;
	const { available } = useContext(StrategyCategoryOrderContext);
	const strategyCategory = available.find(
		(strategyCategory) => strategyCategory._id === strategyCategoryId
	);
	const { backgroundPattern }: any = useTheme();

	useEffect(() => {
		setLeafNav(navigation);
	}, [navigation]);

	useEffect(() => {
		if (!strategyCategory) {
			navigation.goBack();
		}
	}, []);

	const categoryTitle = strategyCategory.category ? (
		<InlineRichText doc={strategyCategory.category} />
	) : (
		strategyCategory.title
	);

	return (
		<Container>
			<Background source={backgroundPattern} />
			<Body>
				<Title type="h3">{categoryTitle}</Title>
				<StrategyList>
					{strategyCategory.strategies.map((strategy) => (
						<StrategyListItem
							key={strategy._id}
							strategy={strategy}
							isNew={strategy._meta.isNew}
							onPress={() => {
								markContentAsRead(strategy._id);
								navigation.navigate("Strategy", {
									strategyId: strategy._id,
								});
							}}
						/>
					))}
				</StrategyList>
			</Body>
		</Container>
	);
};

export default StrategyCategory;
